export  function resetFontSize() {
        let script = document.createElement('script')
        // 强制禁止用户修改微信客户端的字体大小
        script.innerHTML = `
            if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
                handleFontSize();
            } else {
                if (document.addEventListener) {
                    document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
                } else if (document.attachEvent) {
                    document.attachEvent("WeixinJSBridgeReady", handleFontSize);
                    document.attachEvent("onWeixinJSBridgeReady", handleFontSize);  }
            }
            function handleFontSize() {
                WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
                WeixinJSBridge.on('menu:setfont', function() {
                    WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
                });
            }
        `
        const bo = document.getElementsByTagName('body')[0]
        bo.insertBefore(script,document.getElementById('app'));
}



// WEBPACK FOOTER //
// ./src/utils/wxFontSize.js